import { render, staticRenderFns } from "./FormItemSet.vue?vue&type=template&id=ddbb560a&scoped=true"
import script from "./FormItemSet.vue?vue&type=script&lang=js"
export * from "./FormItemSet.vue?vue&type=script&lang=js"
import style0 from "./FormItemSet.vue?vue&type=style&index=0&id=ddbb560a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbb560a",
  null
  
)

export default component.exports